module.exports = __webpack_public_path__ + "static/media/hamburger-icon-index.f1f17279.svg";